<template>
  <div>
    <div class="api-row">
      <ApiKeyCard></ApiKeyCard>
      <!-- <Recognition></Recognition>
      <ProxySettings></ProxySettings> -->
    </div>
    <ApiKeyHistory></ApiKeyHistory>
  </div>
</template>


<script>
import ApiKeyCard from "../../../../components/user/profileSettings/api/ApiKeyCard";
//import Recognition from "../../../../components/user/profileSettings/api/Recognition";
//import ProxySettings from "../../../../components/user/profileSettings/api/ProxySettings";
import ApiKeyHistory from "../../../../components/user/profileSettings/api/ApiRequestHistory";
export default {
  components: {
    ApiKeyCard,
   // Recognition,
   // ProxySettings,
    ApiKeyHistory
  }
};
</script>

<style scoped>
.api-row {
  display: flex;
  justify-content: center;
}
@media only screen and (max-width: 1250px) {
  .api-row {
    flex-wrap: wrap !important;
    justify-content: first baseline;
  }
  .api-key-card-main,
  .recognition-card-main,
  .proxy-settings-card-main {
    max-width: 44% !important;
    width: 44% !important;
    flex: 44% !important;
    margin-bottom: 32px !important;
  }
}


@media only screen and (max-width: 600px){
     .api-key-card-main,
  .recognition-card-main,
  .proxy-settings-card-main {
    max-width: 100% !important;
    width: 100% !important;
    flex: 100% !important;
    margin-bottom: 32px !important;
  }
}
</style>